/**
 * Paleta categórica dos gráficos de resíduo do Dashboard — manual de marca
 * "Paleta de Dados" v1 (tokens.css), na ordem 01→14, com a cor 13 (grafite,
 * #6B6F7A) reservada para "Outros"/excedente em vez de material.
 *
 * A cor é atribuída por RANK de representatividade dentro de cada gráfico
 * (maior valor no período = paleta 01), não por material_id fixo — por
 * decisão de produto, um mesmo resíduo pode ter cor diferente em gráficos
 * diferentes, já que o rank depende do recorte de cada um.
 */
export const RANKED_MATERIAL_PALETTE: string[] = [
  "#8aa5ff",
  "#ffba86",
  "#3e5aa8",
  "#c4703f",
  "#5e9e96",
  "#9b6fa7",
  "#dfc24f",
  "#171c32",
  "#e9a8a8",
  "#4e7343",
  "#c2d0ff",
  "#ffd9bc",
  "#8a6240",
];

/** Cor 13 do manual (grafite) — reservada para excedente além da paleta. */
export const OUTROS_MATERIAL_COLOR = "#6B6F7A";

export const getMaterialColorByRank = (rank: number): string =>
  RANKED_MATERIAL_PALETTE[rank] ?? OUTROS_MATERIAL_COLOR;
